
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dataprotection",
      function () {
        return require("private-next-pages/dataprotection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dataprotection"])
      });
    }
  